import { render } from "./DisablePage.vue?vue&type=template&id=a551f332&scoped=true"
import script from "./DisablePage.vue?vue&type=script&lang=js"
export * from "./DisablePage.vue?vue&type=script&lang=js"

import "./DisablePage.vue?vue&type=style&index=0&id=a551f332&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a551f332"]])

export default __exports__